import {ILink} from "../Api";
import {ISettings, ITimer} from "../../redux/modules/team/types";

export default class TeamResponse {

    public href: string;
    public links: ILink[];
    public name: string;
    public slug: string;
    public settings: ISettings;
    public timer: ITimer;

    constructor(json: any) {
        this.href = json.href;
        this.links = json.links;
        this.name = json.name;
        this.slug = json.slug;
        this.settings = json.settings;
        this.timer = json.timer;
    }
}



// WEBPACK FOOTER //
// ./src/api/responses/TeamResponse.ts